import { useEffect, useState } from 'react'
import BottomSheetContent from '../BottomSheetContent'
import { EventNames } from '../../../types/misc.types'
import { postCTA, trackEvent } from '../../../utils/appBridge'
import { ProcessingPartnerMaintenance } from '../../../types/mf-execution.types'

type ProcessingPartnerMaintenanceBottomSheetProps = {
  maintenance: ProcessingPartnerMaintenance
  onClose: () => void
  ScreenName: string
  fundIsin?: string
}

export function ProcessingPartnerMaintenanceBottomSheet({
  maintenance,
  onClose,
  ScreenName,
  fundIsin
}: ProcessingPartnerMaintenanceBottomSheetProps) {
  const [isNotified, setIsNotified] = useState(false)

  useEffect(() => {
    trackEvent({
      eventName: EventNames.BottomSheetLoad,
      payload: {
        eventId: maintenance?.title ?? 'Processing partner maintenance',
        bottomSheetName: 'Processing partner maintenance',
        ScreenName
      }
    })
  }, [ScreenName, maintenance?.title])

  const handleNotifyClick = () => {
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ScreenName,
        buttonLabel: "Notify me when it's back",
        eventId: 'MFE_PROCESSING_PARTNER_MAINTENANCE_NOTIFY',
        ...(fundIsin ? { fundIsin } : {})
      }
    })

    if (maintenance?.notifyCta) {
      postCTA(JSON.stringify(maintenance.notifyCta))
    }

    setIsNotified(true)
  }

  const handleCloseClick = () => {
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ScreenName,
        buttonLabel: 'Close',
        eventId: 'MFE_PROCESSING_PARTNER_MAINTENANCE_CLOSE'
      }
    })
    onClose()
  }

  return (
    <BottomSheetContent
      heading=''
      headingComponent={
        <div className='flex flex-col items-start px-5 mb-2 pt-2'>
          <div className='mb-4'>
            <img src='/images/mf-l2/clock-icon.svg' alt='' className='object-contain' />
          </div>
          <h2 className='text-[22px] font-[500] text-left leading-[130%]'>{maintenance?.title ?? ''}</h2>
        </div>
      }
      onDismiss={handleCloseClick}
      bottomSheetBodyClassName='!px-0 !pb-3'
      bottomSheetCtas={
        <div className='flex flex-col gap-3'>
          {isNotified ? (
            <button
              type='button'
              disabled
              className='w-full h-14 rounded-xl bg-[#F0F4F7] border border-[#EBF2F2] text-[#232323] font-medium text-[16px] flex items-center justify-center gap-2 opacity-100'
            >
              <img src='/images/mf-l2/notification-icon.svg' alt='' className='brightness-0' />
              <span>We will notify you</span>
            </button>
          ) : (
            <button
              type='button'
              onClick={handleNotifyClick}
              className='w-full h-14 rounded-xl bg-[#232323] text-white font-medium text-[16px] flex items-center justify-center gap-2 outline-none focus:outline-none'
            >
              <img src='/images/mf-l2/notification-icon.svg' alt='' />
              <span>Notify me when it&apos;s back</span>
            </button>
          )}
          <button
            type='button'
            onClick={handleCloseClick}
            className='w-full h-14 rounded-xl border border-[#EBF2F2] bg-white text-[#232323] font-medium text-[16px] outline-none focus:outline-none'
          >
            Close
          </button>
        </div>
      }
    >
      <div className='px-5'>
        <p className='text-[#6A6E6E] text-[14px] font-[400] leading-[150%] text-left'>
          {maintenance?.description ?? ''}
        </p>
      </div>
    </BottomSheetContent>
  )
}
